function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2021/7/28 下午6:13
 */ import { equals, has, head, isNil, pick } from "ramda";
import Sockjs from "sockjs-client";
import { Button, notification } from "antd";
import { over } from "webstomp-client";
import { noticeObserver, NoticeObserverType } from "@/utils/index";
import { CleanCache } from "@/components/cleanCache";
import { open } from "@/components/popup";
import $style from "@/views/notice/index.scss";
var _url = /*#__PURE__*/ new WeakMap(), _nameSpace = /*#__PURE__*/ new WeakMap();
export class Socket {
    get destination() {
        return `/user/queue/${_class_private_field_get(this, _nameSpace)}`;
    }
    init() {
        const sockjs = new Sockjs(`${_class_private_field_get(this, _url)}?nameSpace=${_class_private_field_get(this, _nameSpace)}&accessToken=${localStorage.getItem("rantion-erp-accessToken")}`);
        const stompClient = over(sockjs, {
            debug: false
        });
        this.client = stompClient;
        stompClient.connect({}, ()=>{
            this.hdEvent();
        });
    }
    hdEvent() {
        this.client.subscribe(this.destination, (responseBody)=>{
            if (responseBody.headers["content-type"] === "application/json") {
                const body = JSON.parse(responseBody.body);
                if (has("messageList", body) && body.messageList) {
                    const message = head(body.messageList);
                    if (message) {
                        hdListen(message);
                        const userCode = localStorage.getItem("rantion-erp-userNo") || "";
                        API.mns.messageUser.markRead.request({
                            messageId: message.messageId,
                            userCode
                        }).then((param)=>{
                            let { success } = param;
                            if (success) {
                                noticeObserver.dispatchEvent(NoticeObserverType.refresh);
                            }
                        });
                    }
                } else {
                    const data = body;
                    hdListen(data);
                    // noticeObserver.dispatchEvent('refresh')
                    const userCode = localStorage.getItem("rantion-erp-userNo") || "";
                    API.mns.messageUser.markRead.request({
                        messageId: data.messageId,
                        userCode
                    }); // 标记这个消息已读
                }
            }
        });
        window.onclose = ()=>{
            this.disconnect();
        };
    }
    get readyState() {
        return this.client.ws.readyState;
    }
    // 发送消息
    sendMessage(data) {
        if (isNil(this.client)) {
            return;
        }
        this.client.send(this.destination, data);
    }
    // 关闭链接
    disconnect() {
        var _this_client_ws;
        this.client.abort(this.destination);
        (_this_client_ws = this.client.ws) === null || _this_client_ws === void 0 ? void 0 : _this_client_ws.close();
    }
    constructor(url, nameSpace){
        _define_property(this, "client", void 0); // 当前webSocketIns 实例
        _class_private_field_init(this, _url, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _nameSpace, {
            writable: true,
            value: void 0
        });
        _class_private_field_set(this, _url, url);
        _class_private_field_set(this, _nameSpace, nameSpace ?? "MNS2107230000070");
        this.init();
    }
}
let socket;
export function getSocket() {
    if (isNil(localStorage.getItem("rantion-erp-accessToken"))) {
        return;
    }
    if (!isNil(socket)) {
        return socket;
    }
    if (origin.includes("http://127.0.0.1/") || origin.includes("http://localhost/")) {
        return;
    }
    if (process.env.NODE_ENV === "development") {
        return null;
    }
    socket = new Socket("/serverApi/rantion-mns/mns");
    return socket;
}
function windNotification(data) {
    Notification.requestPermission().then(function(permission) {
        if (permission === "granted") {
            const not = new Notification(data.title, {
                icon: "https://www.rantion-admin.com/favicon.ico"
            });
            not.onclick = function(event) {
                event.preventDefault();
                window.open(data.url, "_blank");
            };
        }
    });
}
function hdListen(data) {
    if (equals(data.categoryCode, "MCA2108030000010")) {
        //　这个是版本通知
        open({
            showFooter: false,
            width: 900,
            title: data.title,
            content: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        dangerouslySetInnerHTML: {
                            __html: data.content
                        }
                    }),
                    /*#__PURE__*/ _jsx(CleanCache, {})
                ]
            })
        });
    } else {
        notification.open({
            message: data.title,
            description: /*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: data.content
                }
            }),
            btn: data.url ? /*#__PURE__*/ _jsx(Button, {
                type: "primary",
                className: `${$style.btn} ${$style.btnPrimary}`,
                onClick: ()=>{
                    window.open(data.url, "_blank");
                },
                children: "马上处理"
            }) : null
        });
        if (localStorage.getItem("noticeTip") === "0" || isNil(data.url)) {
            return;
        }
        windNotification(pick([
            "title",
            "url"
        ], data));
    }
}
